export const FETCH_MEDICLAIM_INVOICELIST_REQUEST = "FETCH_MEDICLAIM_INVOICELIST_REQUEST";
export const FETCH_MEDICLAIM_INVOICELIST_SUCCESS = "FETCH_MEDICLAIM_INVOICELIST_SUCCESS";
export const FETCH_MEDICLAIM_INVOICELIST_FAILURE = "FETCH_MEDICLAIM_INVOICELIST_FAILURE";
